export class StatisticsData {
  constructor(creationDate, schemeVersion, statisticsType, data, networkConnection, user, sessionId) {
    this.creationDate = creationDate
    this.schemeVersion = schemeVersion
    this.statisticsType = statisticsType
    this.data = data
    this.networkConnection = networkConnection
    this.user = user
    this.sessionId = sessionId
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/StatisticsData.js